module.exports = __webpack_public_path__ + "src/img/cloudIcon.e9134109.svg";